export const FB_WORKPLACE = 'fb_workplace';
export const SLACK = 'slack';
export const MS_TEAMS = 'ms_teams';

export const CONVERSATION_TYPES = {
    DIRECT_MESSAGE: 'direct_message',
    PRIVATE_CHANNEL: 'private_channel',
    PUBLIC_CHANNEL: 'public_channel',
};

export interface ThirdParty {
    google_analytics_id: string;
    google_analytics_id_for_course_taking: string;
    google_tag_manager_id: string;
    google_analytics_id_for_ufb_only: string;
    facebook_app_id: string;
    raven_dsn: string;
    sift_account: boolean;
    uft_stripe_publishable_key: string;
    branch_metrics: {
        ios_download_url: string;
        ios_ufb_download_url: string;
        android_download_url: string;
        android_ufb_download_url: string;
    };
    pusher: {
        key: string;
        coding_exercise_event: string;
    };
    zendesk: {
        refund_form_id: number;
    };
    filestack: {
        key: string;
    };
    paypal: {
        appid: string;
        authend: string;
        returnurl: string;
    };
    s3: {
        asset: {
            key: string;
            bucket_url: string;
        };
        image_asset: {
            key: string;
            bucket_url: string;
        };
    };
    storage_static_asset_base_url: string;
    google_client_id: string;
}
